import { render, staticRenderFns } from "./PageDesignAndPlanning.vue?vue&type=template&id=4d48a3bd&"
import script from "./PageDesignAndPlanning.vue?vue&type=script&lang=js&"
export * from "./PageDesignAndPlanning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports